import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { ResponsePackage } from "../models/util.model";
import { AdvancedMapDataOut } from "../models/advancedMap.model";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})

export class AdvancedMapService{
    private pathApi = this.config.setting['pathApi'] + "advancedMap/";
    private headers = new HttpHeaders({'Content-Type': 'application/json'});
    
    constructor(private http: HttpClient, private config: AppConfig) {}

    getMapData(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}getMapData`, obj, { headers: this.headers, observe: 'response' });
    }

    getMapCimData(obj: any): Observable<any> {
      return this.http.post(`${this.pathApi}getMapCimData`, obj, { headers: this.headers, observe: 'response' });
    }

    getConnectedAssets(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}getLines`, obj, { headers: this.headers, observe: 'response' });
    }

    getConnectedCimAssets(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}getCimLines`, obj, { headers: this.headers, observe: 'response' });
    }

    searchAccountNumber(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}searchAccountNumber`, obj, { headers: this.headers, observe: 'response'});
    }

    searchDtSlrn(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}searchDtSlrn`, obj, { headers: this.headers, observe: 'response'});
    }

    searchCimSubstationSlrn(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}searchCimSubstationSlrn`, obj, { headers: this.headers, observe: 'response'});
    }

    searchBuildingSlrn(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}searchBuildingSlrn`, obj, { headers: this.headers, observe: 'response'});
    }
    searchMeterNumber(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}searchMeterNumber`, obj, { headers: this.headers, observe: 'response'});
    }

    searchMeterSlrn(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}searchMeterSlrn`, obj, { headers: this.headers, observe: 'response'});
    }

    searchLvPoleSlrn(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}searchLvPoleSlrn`, obj, { headers: this.headers, observe: 'response'});
    }

    getBuildingsCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getBuildingsCount`, obj, {headers: this.headers, observe: 'response'});
    }

    getCustomersCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getCustomersCount`, obj, {headers: this.headers, observe: 'response'});
    }

    getDtsCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getDtsCount`, obj, {headers: this.headers, observe: 'response'});
    }

    getPolesCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getPolesCount`, obj, {headers: this.headers, observe: 'response'});
    }
    
    getSubstationsCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getSubstationsCount`, obj, {headers: this.headers, observe: 'response'});
    }

    getTsCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getTsCount`, obj, {headers: this.headers, observe: 'response'});
    }
    
    getFeedersCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getFeedersCount`, obj, {headers: this.headers, observe: 'response'});
    }

    getDevicesCount(obj : any){
      return this.http.post<any>(`${this.pathApi}getDevicesCount`, obj, {headers: this.headers, observe: 'response'});
    }

    getCimCounts(obj : any){
      return this.http.post<any>(`${this.pathApi}getCimCounts`, obj, {headers: this.headers, observe: 'response'});
    }

    updateAssetLocation(obj : any){
      return this.http.post<any>(`${this.pathApi}updateAssetLocationAndConnections`, obj, {headers: this.headers, observe: 'response'});
    }
}

